import { render, staticRenderFns } from "./footerInfo.vue?vue&type=template&id=08df77b2&scoped=true&"
import script from "./footerInfo.vue?vue&type=script&lang=js&"
export * from "./footerInfo.vue?vue&type=script&lang=js&"
import style0 from "./footerInfo.vue?vue&type=style&index=0&id=08df77b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08df77b2",
  null
  
)

export default component.exports